import {
  IOperationProofOfPayoutDownload,
  IWallet,
  IWalletAccountDetailsDownload,
  IWalletBalanceCertificateDownload,
  IWalletClosureCertficateDownload,
  IWalletDomiciliationCertificateDownload,
  IWalletStatementDownload,
} from '@/features/wallets/store/models/wallet.model';
import { IWalletOperationDownload, TWalletOperation } from '@/features/wallets/store/models/walletOperation.model';

import { ICursorElements } from '@/store/types/search.types';

import { TAppError, IBaseAction } from '@/store/types/base.state';

export enum WalletActionTypes {
  GET_WALLET_ACCOUNT_DETAILS = 'PROFILE.GET_WALLET_ACCOUNT_DETAIL',
  GET_WALLET_ACCOUNT_DETAILS_SUCCESS = 'PROFILE.GET_WALLET_ACCOUNT_DETAIL_SUCCESS',
  GET_WALLET_ACCOUNT_DETAILS_FAIL = 'PROFILE.GET_WALLET_ACCOUNT_DETAIL_FAIL',

  GET_WALLET_STATEMENT = 'PROFILE.GET_WALLET_STATEMENT',
  GET_WALLET_STATEMENT_SUCCESS = 'PROFILE.GET_WALLET_STATEMENT_SUCCESS',
  GET_WALLET_STATEMENT_FAIL = 'PROFILE.GET_WALLET_STATEMENT_FAIL',

  CREATE_WALLET = 'PROFILE.CREATE_WALLET',
  CREATE_WALLET_SUCCESS = 'PROFILE.CREATE_WALLET_SUCCESS',
  CREATE_WALLET_FAIL = 'PROFILE.CREATE_WALLET_FAIL',

  UPDATE_WALLET = 'PROFILE.UPDATE_WALLET',
  UPDATE_WALLET_SUCCESS = 'PROFILE.UPDATE_WALLET_SUCCESS',
  UPDATE_WALLET_FAIL = 'PROFILE.UPDATE_WALLET_FAIL',

  GET_WALLET = 'PROFILE.GET_WALLET',
  GET_WALLET_SUCCESS = 'PROFILE.GET_WALLET_SUCCESS',
  GET_WALLET_FAIL = 'PROFILE.GET_WALLET_FAIL',

  GET_WALLETS = 'PROFILE.GET_WALLETS',
  GET_WALLETS_SUCCESS = 'PROFILE.GET_WALLETS_SUCCESS',
  GET_WALLETS_FAIL = 'PROFILE.GET_WALLETS_FAIL',

  UNSET_WALLETS = 'PROFILE.UNSET_WALLETS',

  SET_CURRENT_WALLET = 'PROFILE.SET_CURRENT_WALLET',

  SET_CURRENT_WALLET_OPERATIONS = 'PROFILE.SET_CURRENT_WALLET_OPERATIONS',

  GET_CURRENT_WALLET_OPERATIONS = 'PROFILE.GET_CURRENT_WALLET_OPERATIONS',
  GET_CURRENT_WALLET_OPERATIONS_SUCCESS = 'PROFILE.GET_CURRENT_WALLET_OPERATIONS_SUCCESS',
  GET_CURRENT_WALLET_OPERATIONS_FAIL = 'PROFILE.GET_CURRENT_WALLET_OPERATIONS_FAIL',

  DEACTIVATE_WALLET = 'PROFILE.DEACTIVATE_WALLET',
  DEACTIVATE_WALLET_SUCCESS = 'PROFILE.DEACTIVATE_WALLET_SUCCESS',
  DEACTIVATE_WALLET_FAIL = 'PROFILE.DEACTIVATE_WALLET_FAIL',

  SIMULATE_SCTR = 'PROFILE.SIMULATE_SCTR',
  SIMULATE_SCTR_SUCCESS = 'PROFILE.SIMULATE_SCTR_SUCCESS',
  SIMULATE_SCTR_FAIL = 'PROFILE.SIMULATE_SCTR_FAIL',

  SIMULATE_OPERATION = 'PROFILE.SIMULATE_OPERATION',
  SIMULATE_OPERATION_SUCCESS = 'PROFILE.SIMULATE_OPERATION_SUCCESS',
  SIMULATE_OPERATION_FAIL = 'PROFILE.SIMULATE_OPERATION_FAIL',

  REQUEST_OPERATIONS_REPORT = 'PROFILE.REQUEST_OPERATIONS_REPORT',
  REQUEST_OPERATIONS_REPORT_SUCCESS = 'PROFILE.REQUEST_OPERATIONS_REPORT_SUCCESS',
  REQUEST_OPERATIONS_REPORT_FAIL = 'PROFILE.REQUEST_OPERATIONS_REPORT_FAIL',

  GET_OPERATIONS_REPORT = 'PROFILE.GET_OPERATIONS_REPORT',
  GET_OPERATIONS_REPORT_SUCCESS = 'PROFILE.GET_OPERATIONS_REPORT_SUCCESS',
  GET_OPERATIONS_REPORT_FAIL = 'PROFILE.GET_OPERATIONS_REPORT_FAIL',

  RESET_OPERATIONS_REPORT = 'PROFILE.RESET_OPERATIONS_REPORT',

  GET_WALLET_DOMICILIATION_CERTIFICATE = 'PROFILE.GET_WALLET_DOMICILIATION_CERTIFICATE',
  GET_WALLET_DOMICILIATION_CERTIFICATE_SUCCESS = 'PROFILE.GET_WALLET_DOMICILIATION_CERTIFICATE_SUCCESS',
  GET_WALLET_DOMICILIATION_CERTIFICATE_FAIL = 'PROFILE.GET_WALLET_DOMICILIATION_CERTIFICATE_FAIL',

  GET_WALLET_BALANCE_CERTIFICATE = 'PROFILE.GET_WALLET_BALANCE_CERTIFICATE',
  GET_WALLET_BALANCE_CERTIFICATE_SUCCESS = 'PROFILE.GET_WALLET_BALANCE_CERTIFICATE_SUCCESS',
  GET_WALLET_BALANCE_CERTIFICATE_FAIL = 'PROFILE.GET_WALLET_BALANCE_CERTIFICATE_FAIL',

  GET_WALLET_CLOSURE_CERTIFICATE = 'PROFILE.GET_WALLET_CLOSURE_CERTIFICATE',
  GET_WALLET_CLOSURE_CERTIFICATE_SUCCESS = 'PROFILE.GET_WALLET_CLOSURE_CERTIFICATE_SUCCESS',
  GET_WALLET_CLOSURE_CERTIFICATE_FAIL = 'PROFILE.GET_WALLET_CLOSURE_CERTIFICATE_FAIL',

  GET_OPERATION_PROOF_OF_PAYOUT = 'PROFILE.GET_OPERATION_PROOF_OF_PAYOUT',
  GET_OPERATION_PROOF_OF_PAYOUT_SUCCESS = 'PROFILE.GET_OPERATION_PROOF_OF_PAYOUT_SUCCESS',
  GET_OPERATION_PROOF_OF_PAYOUT_FAIL = 'PROFILE.GET_OPERATION_PROOF_OF_PAYOUTL_FAIL',
}

export interface IGetWalletAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET;
  walletId: number;
}

export interface IGetWalletSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_SUCCESS;
  userId: number;
  walletId: number;
  wallet: IWallet;
}

export interface IGetWalletFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_FAIL;
  walletId: number;
  error: TAppError;
}

export interface IGetWalletsAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLETS;
  userId: number;
}

export interface IGetWalletsSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLETS_SUCCESS;
  userId: number;
  wallets: IWallet[];
}

export interface IGetWalletsFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLETS_FAIL;
  userId: number;
  error: TAppError;
}

export interface ISetCurrentWalletOperationsAction extends IBaseAction {
  type: typeof WalletActionTypes.SET_CURRENT_WALLET_OPERATIONS;
  userId: number;
  walletId: number;
  paginateOperations: ICursorElements<TWalletOperation>;
}

export interface IGetCurrentWalletOperationsAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_CURRENT_WALLET_OPERATIONS;
  userId: number;
  walletId: number;
}

export interface IGetCurrentWalletOperationsSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_CURRENT_WALLET_OPERATIONS_SUCCESS;
  userId: number;
  walletId: number;
  paginateOperations: ICursorElements<TWalletOperation>;
}

export interface IGetCurrentWalletOperationsFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_CURRENT_WALLET_OPERATIONS_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface ISetCurrentWalletAction extends IBaseAction {
  type: typeof WalletActionTypes.SET_CURRENT_WALLET;
  userId: number;
  currentWalletId: number;
}

export interface IUnsetProfileWalletsAction extends IBaseAction {
  type: typeof WalletActionTypes.UNSET_WALLETS;
  userId: number;
}

export interface IDeactivateWalletAction extends IBaseAction {
  type: typeof WalletActionTypes.DEACTIVATE_WALLET;
  userId: number;
  walletId: number;
}

export interface IDeactivateWalletSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.DEACTIVATE_WALLET_SUCCESS;
  wallet: IWallet;
}

export interface IDeactivateWalletFailAction extends IBaseAction {
  type: typeof WalletActionTypes.DEACTIVATE_WALLET_FAIL;
  error: TAppError;
  userId: number;
  walletId: number;
}

export interface IGetWalletAccountDetailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_ACCOUNT_DETAILS;
  userId: number;
  walletId: number;
}
export interface IGetWalletAccountDetailSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_ACCOUNT_DETAILS_SUCCESS;
  userId: number;
  walletId: number;
  walletAccountDetail: IWalletAccountDetailsDownload;
}
export interface IGetWalletAccountDetailFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_ACCOUNT_DETAILS_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface IGetWalletDomiciliationCertificateAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_DOMICILIATION_CERTIFICATE;
  userId: number;
  walletId: number;
}
export interface IGetWalletDomiciliationCertificateSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_DOMICILIATION_CERTIFICATE_SUCCESS;
  userId: number;
  walletId: number;
  domiciliationCertificate: IWalletDomiciliationCertificateDownload;
}
export interface IGetWalletDomiciliationCertificateFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_DOMICILIATION_CERTIFICATE_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface IGetWalletBalanceCertificateAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_BALANCE_CERTIFICATE;
  userId: number;
  walletId: number;
}
export interface IGetWalletBalanceCertificateSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_BALANCE_CERTIFICATE_SUCCESS;
  userId: number;
  walletId: number;
  balanceCertificate: IWalletBalanceCertificateDownload;
}
export interface IGetWalletBalanceCertificateFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_BALANCE_CERTIFICATE_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface IGetWalletClosureCertificateAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_CLOSURE_CERTIFICATE;
  userId: number;
  walletId: number;
}
export interface IGetWalletClosureCertificateSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_CLOSURE_CERTIFICATE_SUCCESS;
  userId: number;
  walletId: number;
  closureCertificate: IWalletClosureCertficateDownload;
}
export interface IGetWalletClosureCertificateFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_CLOSURE_CERTIFICATE_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface IGetWalletStatementAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_STATEMENT;
  userId: number;
  walletId: number;
}
export interface IGetWalletStatementSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_STATEMENT_SUCCESS;
  userId: number;
  walletId: number;
  statement: IWalletStatementDownload;
}
export interface IGetWalletStatementFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_WALLET_STATEMENT_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface ICreateWalletAction extends IBaseAction {
  type: typeof WalletActionTypes.CREATE_WALLET;
  userId: number;
}

export interface ICreateWalletSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.CREATE_WALLET_SUCCESS;
  wallet: IWallet;
}

export interface ICreateWalletFailAction extends IBaseAction {
  type: typeof WalletActionTypes.CREATE_WALLET_FAIL;
  userId: number;
  error: TAppError;
}

export interface IUpdateWalletAction extends IBaseAction {
  type: typeof WalletActionTypes.UPDATE_WALLET;
  userId: number;
  walletId: number;
}

export interface IUpdateWalletSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.UPDATE_WALLET_SUCCESS;
  wallet: IWallet;
}

export interface IUpdateWalletFailAction extends IBaseAction {
  type: typeof WalletActionTypes.UPDATE_WALLET_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface ISimulateSctrAction extends IBaseAction {
  type: typeof WalletActionTypes.SIMULATE_SCTR;
  userId: number;
  walletId: number;
}

export interface ISimulateSctrSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.SIMULATE_SCTR_SUCCESS;
  userId: number;
  walletId: number;
}

export interface ISimulateSctrFailAction extends IBaseAction {
  type: typeof WalletActionTypes.SIMULATE_SCTR_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface ISimulateOperationAction extends IBaseAction {
  type: typeof WalletActionTypes.SIMULATE_OPERATION;
  userId: number;
  walletId: number;
}

export interface ISimulateOperationSuccessAction extends IBaseAction {
  type: typeof WalletActionTypes.SIMULATE_OPERATION_SUCCESS;
  userId: number;
  walletId: number;
}

export interface ISimulateOperationFailAction extends IBaseAction {
  type: typeof WalletActionTypes.SIMULATE_OPERATION_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface IRequestOperations extends IBaseAction {
  type: typeof WalletActionTypes.REQUEST_OPERATIONS_REPORT;
  userId: number;
  walletId: number;
}

export interface IRequestOperationsSucessAction extends IBaseAction {
  type: typeof WalletActionTypes.REQUEST_OPERATIONS_REPORT_SUCCESS;
  userId: number;
  walletId: number;
  operation: IWalletOperationDownload;
}

export interface IRequestOperationsFailAction extends IBaseAction {
  type: typeof WalletActionTypes.REQUEST_OPERATIONS_REPORT_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface IGetOperationsReportAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_OPERATIONS_REPORT;
  userId: number;
  walletId: number;
}

export interface IGetOperationsReportSucessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_OPERATIONS_REPORT_SUCCESS;
  userId: number;
  walletId: number;
  operation: IWalletOperationDownload;
}

export interface IGetOperationsReportFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_OPERATIONS_REPORT_FAIL;
  userId: number;
  walletId: number;
  error: TAppError;
}

export interface IResetOperationReportAction extends IBaseAction {
  type: typeof WalletActionTypes.RESET_OPERATIONS_REPORT;
  userId: number;
  walletId: number;
}

export interface IGetOperationProofOfPayoutAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_OPERATION_PROOF_OF_PAYOUT;
  userId: number;
  walletId: number;
  objectId: string;
}

export interface IGetOperationProofOfPayoutSucessAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_OPERATION_PROOF_OF_PAYOUT_SUCCESS;
  userId: number;
  walletId: number;
  objectId: string;
  proofOfPayout: IOperationProofOfPayoutDownload;
}

export interface IGetOperationProofOfPayoutFailAction extends IBaseAction {
  type: typeof WalletActionTypes.GET_OPERATION_PROOF_OF_PAYOUT_FAIL;
  userId: number;
  walletId: number;
  objectId: string;
  error: TAppError;
}

export type TWalletAction =
  | ICreateWalletAction
  | ICreateWalletSuccessAction
  | ICreateWalletFailAction
  | IGetWalletAction
  | IGetWalletSuccessAction
  | IGetWalletFailAction
  | IGetWalletsAction
  | IGetWalletsSuccessAction
  | IGetWalletsFailAction
  | ISetCurrentWalletOperationsAction
  | IGetCurrentWalletOperationsAction
  | IGetCurrentWalletOperationsFailAction
  | IGetCurrentWalletOperationsSuccessAction
  | IDeactivateWalletAction
  | IDeactivateWalletSuccessAction
  | IDeactivateWalletFailAction
  | ISetCurrentWalletAction
  | IUnsetProfileWalletsAction
  | IGetWalletAccountDetailAction
  | IGetWalletAccountDetailSuccessAction
  | IGetWalletAccountDetailFailAction
  | IGetWalletStatementAction
  | IGetWalletStatementSuccessAction
  | IGetWalletStatementFailAction
  | IUpdateWalletAction
  | IUpdateWalletSuccessAction
  | IUpdateWalletFailAction
  | IRequestOperations
  | IRequestOperationsSucessAction
  | IRequestOperationsFailAction
  | IGetOperationsReportFailAction
  | IGetOperationsReportAction
  | IGetOperationsReportSucessAction
  | IResetOperationReportAction
  | ISimulateSctrAction
  | ISimulateSctrSuccessAction
  | ISimulateSctrFailAction
  | ISimulateOperationAction
  | ISimulateOperationSuccessAction
  | ISimulateOperationFailAction
  | IGetWalletDomiciliationCertificateAction
  | IGetWalletDomiciliationCertificateSuccessAction
  | IGetWalletDomiciliationCertificateFailAction
  | IGetWalletBalanceCertificateAction
  | IGetWalletBalanceCertificateSuccessAction
  | IGetWalletBalanceCertificateFailAction
  | IGetWalletClosureCertificateAction
  | IGetWalletClosureCertificateSuccessAction
  | IGetWalletClosureCertificateFailAction
  | IGetOperationProofOfPayoutAction
  | IGetOperationProofOfPayoutSucessAction
  | IGetOperationProofOfPayoutFailAction;
